import {
  fetchLeads,
  fetchPipelines,
  getTags,
} from "@/services/api/apiServiceLeads";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  namespaced: true,
  state: {
    isLoading: false,
    isPipelinesLoading: false,
    pipeLines: [],
    currentPage: 1,
    perPage: null,
    selectedLeadItemId: null,
    tags: [],
    selectedTags: [],
    searchQuery: null,
    isSearch: false,
    activeMobilePipeline: null,
  },
  mutations: {
    setLoading(state, value) {
      state.isLoading = value;
    },
    setPipeLines(state, pipeLines) {
      state.pipeLines = pipeLines;
      state.isLoading = false;
    },
    addNewPipeLine(state, newPipeLine) {
      state.pipeLines.push(newPipeLine);
    },
    setLeads(state, { leads, pipelineId }) {
      const pipeLine = state.pipeLines.find(
        (pipeLine) => pipeLine.id === pipelineId,
      );
      if (pipeLine) {
        pipeLine.leads.data = leads?.data;
        pipeLine.leads.total = leads?.total;
      }
    },
    setCursor(state, { cursor, pipelineId }) {
      const pipeLine = state.pipeLines.find(
        (pipeLine) => pipeLine.id === pipelineId,
      );
      if (pipeLine) {
        pipeLine.nextPageCursor = cursor;
      }
    },
    pushNewLeads(state, { newLeads, pipelineId }) {
      const pipeLine = state.pipeLines.find((p) => p.id === pipelineId);
      if (pipeLine) {
        pipeLine.leads.data.push(...newLeads);
      }
    },
    setSelectedItemId(state, selectedId) {
      state.selectedLeadItemId = selectedId;
    },
    udpateDraggedLeadLocally(
      state,
      { fromPipelineId, toPipelineId, oldleadId, newleadId },
    ) {
      // console.log(oldleadId, newleadId);
      const fromPipeline = state.pipeLines.find(
        (pl) => pl.id === +fromPipelineId,
      );
      const toPipeline = state.pipeLines.find((p) => p.id === +toPipelineId);

      if (!fromPipeline || !toPipeline) {
        console.error("Invalid pipeline IDs provided for lead transfer.");
        return;
      }

      const leadIndex = toPipeline.leads.data.findIndex(
        (l) => l.id == oldleadId,
      );

      if (leadIndex === -1) {
        console.log("lead not found");
        return;
      }

      // Change the lead id in toPipeline to the newleadId
      toPipeline.leads.data[leadIndex].id = newleadId;

      // Change the leads count accordingly
      toPipeline.leads.total += 1;
      toPipeline.leads_count += 1;

      fromPipeline.leads.total -= 1;
      fromPipeline.leads_count -= 1;

      // *********** add archived lead to the prev pl ******************
      // const oldLead = toPipeline.leads.data[leadIndex];
      // fromPipeline.leads.data.push({ ...oldLead, id: oldleadId, is_won: 1 });
      // ****************************************************************
    },
    revertDraggedLeadLocally(state, { fromPipelineId, toPipelineId, leadId }) {
      const fromPipeline = state.pipeLines.find(
        (pl) => pl.id === +fromPipelineId,
      );
      const toPipeline = state.pipeLines.find((p) => p.id === +toPipelineId);

      const leadIndex = toPipeline.leads.data.findIndex((l) => l.id == leadId);

      if (leadIndex === -1) {
        console.log("lead not found");
        return;
      }

      const lead = toPipeline.leads.data[leadIndex];
      toPipeline.leads.data.splice(leadIndex, 1);
      fromPipeline.leads.data.push(lead);
    },
    setPipelineLoadingState(state, { pipelineId, isLoading }) {
      const pipeline = state.pipeLines.find((pl) => pl.id === pipelineId);
      if (pipeline) {
        pipeline.leads.isLoading = isLoading;
      }
    },
    addNewTagToLead(state, { pipelineId, leadId, tag }) {
      const targetPipeline = state.pipeLines.find((p) => p.id == pipelineId);
      if (!targetPipeline) {
        console.error(`Pipeline with ID ${pipelineId} not found.`);
        return;
      }

      const targetLead = targetPipeline.leads.data.find((l) => l.id == leadId);
      if (!targetLead) {
        console.error(
          `Lead with ID ${leadId} not found in pipeline ${pipelineId}.`,
        );
        return;
      }

      // Ensure tags array exists before pushing the new tag
      if (!Array.isArray(targetLead.tags)) {
        targetLead.tags = [];
      }

      targetLead.tags.push(tag);
    },
    removeTagFromLead(state, { pipelineId, leadId, tagId }) {
      const targetPipeline = state.pipeLines.find((p) => p.id == pipelineId);
      if (!targetPipeline) {
        console.error(`Pipeline with ID ${pipelineId} not found.`);
        return;
      }

      const targetLead = targetPipeline.leads.data.find((l) => l.id == leadId);
      if (!targetLead) {
        console.error(
          `Lead with ID ${leadId} not found in pipeline ${pipelineId}.`,
        );
        return;
      }

      if (!Array.isArray(targetLead.tags)) {
        console.error(
          `Tags array not found for lead with ID ${leadId} in pipeline ${pipelineId}.`,
        );
        return;
      }

      const tagIndex = targetLead.tags.findIndex((tag) => tag.id === tagId);
      if (tagIndex === -1) {
        console.error(
          `Tag with ID ${tagId} not found for lead with ID ${leadId}.`,
        );
        return;
      }

      // Remove the tag from the tags array
      targetLead.tags.splice(tagIndex, 1);
    },
    setTags(state, tags) {
      state.tags = tags;
    },
    toggleSelectedTag(state, tag) {
      const index = state.selectedTags.findIndex((t) => t.id === tag.id);
      if (index === -1) {
        state.selectedTags.push(tag); // Add tag
      } else {
        state.selectedTags.splice(index, 1); // Remove tag
      }
    },
    toggleTagIsSelected(state, id) {
      const targetTag = state.tags.find((t) => t.id == id);
      targetTag.isSelected = !targetTag.isSelected;
    },
    setSearchQuery(state, query) {
      state.currentPage = 1;
      state.searchQuery = query;
    },
    setIsSearch(state) {
      if (state.searchQuery || state.selectedTags.length > 0) {
        state.isSearch = true;
      } else {
        state.isSearch = false;
      }
    },
    setIsPipelinesLoading(state, value) {
      state.isPipelinesLoading = value;
    },
    setActiveMobilePipeline(state, pipeline) {
      state.activeMobilePipeline = pipeline;
    },
    setPerPage(state, perPage) {
      if (+state.perPage !== +perPage) state.perPage = perPage;
    },
    updateLeadPipeline(
      state,
      { fromPipelineId, toPipelineId, leadId, newLeadId },
    ) {
      const sourcePipeline = state.pipeLines.find(
        (pipeline) => pipeline.id === fromPipelineId,
      );
      if (!sourcePipeline) {
        console.error(`Source pipeline with ID ${fromPipelineId} not found.`);
        return;
      }

      const destinationPipeline = state.pipeLines.find(
        (pipeline) => pipeline.id === toPipelineId,
      );
      if (!destinationPipeline) {
        console.error(
          `Destination pipeline with ID ${toPipelineId} not found.`,
        );
        return;
      }

      const leadIndex = sourcePipeline.leads.data.findIndex(
        (lead) => lead.id === leadId,
      );
      if (leadIndex === -1) {
        console.error(
          `Lead with ID ${leadId} not found in pipeline ${fromPipelineId}.`,
        );
        return;
      }

      const [lead] = sourcePipeline.leads.data.splice(leadIndex, 1);
      destinationPipeline.leads.data.push({ ...lead, id: newLeadId });
      // sourcePipeline.leads.data.push({...lead, is_won: 1});

      destinationPipeline.leads.total += 1;
      destinationPipeline.leads_count += 1;

      sourcePipeline.leads.total -= 1;
      sourcePipeline.leads_count -= 1;
    },
  },
  actions: {
    async loadPipeLines({ commit }) {
      commit("setLoading", true);
      try {
        const response = await fetchPipelines();
        if (!response) {
          return;
        }
        const orderedResponse = response.sort(
          (a, b) => a.position - b.position,
        );

        const pipelinesWithEmptyLeads = orderedResponse.map((pipeline) => ({
          ...pipeline,
          leads: { data: [], isLoading: false },
        }));
        commit("setPipeLines", pipelinesWithEmptyLeads);
        commit("setActiveMobilePipeline", pipelinesWithEmptyLeads[0]);
      } catch (error) {
        console.error("Error loading pipelines:", error);
        toast.error(
          `مشکلی در بارگزاری پایپ لاین ها به وجود آمد. اتصال به اینترنت را بررسی کنید.`,
        );
      } finally {
        commit("setLoading", false);
      }
    },
    async loadPipeLinesWithoutLoad({ commit }) {
      try {
        commit("setIsPipelinesLoading", true);
        const response = await fetchPipelines();
        if (!response) {
          return;
        }
        const orderedResponse = response.sort(
          (a, b) => a.position - b.position,
        );
        const pipelinesWithEmptyLeads = orderedResponse.map((pipeline) => ({
          ...pipeline,
          leads: { data: [], isLoading: false },
        }));
        commit("setPipeLines", pipelinesWithEmptyLeads);
      } catch (error) {
        console.error("Error loading pipelines:", error);
        toast.error(
          `مشکلی در بارگزاری پایپ لاین ها به وجود آمد. اتصال به اینترنت را بررسی کنید.`,
        );
      } finally {
        commit("setIsPipelinesLoading", false);
      }
    },

    // Action to fetch leads for all pipelines
    async fetchLeadsForPipelines({ commit, state }) {
      const leadFetchPromises = state.pipeLines.map(async (pipeline) => {
        commit("setPipelineLoadingState", {
          pipelineId: pipeline.id,
          isLoading: true,
        });
        try {
          const res = await fetchLeads(
            pipeline.id,
            pipeline.nextPageCursor,
            state.searchQuery,
          );
          commit("setPerPage", res.leads.per_page);
          commit("setLeads", {
            leads: { ...res.leads, total: res.total },
            pipelineId: pipeline.id,
          });
          commit("setCursor", {
            cursor: res.leads.next_cursor,
            pipelineId: pipeline.id,
          });
        } catch (error) {
          console.error(
            `Error fetching leads for pipeline ${pipeline.id}:`,
            error,
          );
          toast.error(
            `مشکلی در بارگزاری اطلاعات پایپ لاین "${pipeline.name}" به وجود آمد.`,
          );
        } finally {
          commit("setPipelineLoadingState", {
            pipelineId: pipeline.id,
            isLoading: false,
          });
        }
      });

      await Promise.all(leadFetchPromises);
    },

    // Action to fetch leads for one specific pipleine
    async fetchLeadsForOnePipeline(
      { commit, state },
      { pipelineId, query = state.searchQuery },
    ) {
      if (!pipelineId) {
        console.error("fetchLeadsForOnePipeline requires a pipelineId");
        return;
      }

      const LEADS_PER_PAGE = state.perPage || 15;
      const count = state.currentPage * LEADS_PER_PAGE;

      commit("setPipelineLoadingState", { pipelineId, isLoading: true });
      commit("setLeads", {
        leads: { data: [], total: 0 },
        pipelineId,
      });

      try {
        const res = await fetchLeads(pipelineId, null, query, count);

        commit("setLeads", {
          leads: { data: res.leads.data, total: res.total },
          pipelineId,
        });
      } catch (error) {
        console.error(
          `Error fetching leads for pipeline ${pipelineId}:`,
          error,
        );
        toast.error(
          `مشکلی در بارگزاری اطلاعات پایپ لاین انتخاب‌شده به وجود آمد.`,
        );
      } finally {
        commit("setPipelineLoadingState", { pipelineId, isLoading: false });
      }
    },

    // Action to load a new page of leads
    async loadNewPage({ commit, state }) {
      state.currentPage++;
      const leadFetchPromises = state.pipeLines.map(async (pipeline) => {
        if (!pipeline.nextPageCursor) return;
        commit("setPipelineLoadingState", {
          pipelineId: pipeline.id,
          isLoading: true,
        });
        try {
          const leads = await fetchLeads(
            pipeline.id,
            pipeline.nextPageCursor,
            state.searchQuery,
          );

          commit("pushNewLeads", {
            newLeads: leads.leads.data,
            pipelineId: pipeline.id,
          });
          commit("setCursor", {
            cursor: leads.leads.next_cursor,
            pipelineId: pipeline.id,
          });
        } catch (error) {
          console.error(
            `Error fetching leads for pipeline ${pipeline.id}:`,
            error,
          );
        } finally {
          commit("setPipelineLoadingState", {
            pipelineId: pipeline.id,
            isLoading: false,
          }); // Set loading state to false
        }
      });

      await Promise.all(leadFetchPromises);
    },

    // Action to load tags
    async loadTagsArray({ commit }) {
      const response = await getTags();
      const formattedRes = response.data.map((t) => {
        return { ...t, isSelected: false };
      });
      commit("setTags", formattedRes);
    },
  },
  getters: {},
};
